import Motion from '@/app/components/Motion';
import MultiCarousel, {
  type ResponsiveType,
} from '@/app/components/MultiCarousel';
import { RESPONSIVE_DATA } from '@/app/components/MultiCarousel/constants';

import PopFinishesCarouselNav from './PopFinishesCarouselNav';
import PopFinishesCarouselSlide from './PopFinishesCarouselSlide';
import type { PopFinishesCarouselSlideData } from './types';

export interface PopFinishesCarouselProps {
  readonly slides: PopFinishesCarouselSlideData[];
}

const RESPONSIVE: ResponsiveType = {
  desktop: { ...RESPONSIVE_DATA['desktop']!, items: 1 },
  tablet: { ...RESPONSIVE_DATA['tablet']!, items: 1 },
  mobile: { ...RESPONSIVE_DATA['mobile']!, items: 1 },
};

const PopFinishesCarousel = ({ slides }: PopFinishesCarouselProps) => {
  return (
    <Motion
      initial={{ opacity: 0 }}
      transition={{ delay: 0.25, duration: 0.75, type: 'tween' }}
      viewport={{ amount: 0.5, once: true }}
      whileInView={{ opacity: 1 }}
    >
      <MultiCarousel
        arrows={false}
        autoPlay={false}
        className="relative h-[540px] overflow-hidden rounded-lg md:aspect-3/2 md:h-auto lg:aspect-2/1"
        customButtonGroup={
          <PopFinishesCarouselNav
            swatches={slides.map((slide) => slide.swatch)}
          />
        }
        responsive={RESPONSIVE}
        shouldResetAutoplay={false}
        showDots={false}
        ssr
      >
        {slides.map((slide) => (
          <PopFinishesCarouselSlide
            key={slide.swatch.label}
            image={slide.image}
          />
        ))}
      </MultiCarousel>
    </Motion>
  );
};

export default PopFinishesCarousel;
